<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  props: {
    categories: Array,
    slideTo: Function,
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      navArray: [],
      swiperOption: {
        slidesPerView: 5,
        centeredSlides: true,
        slideToClickedSlide: true,
        breakpoints: {
          1024: {
            slidesPerView: 5,
            spaceBetween: 80,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          320: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
        //  pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
      },
    };
  },
  created() {
    let data = [
      {
        text: "All Posts",
      },
    ];
    console.warn("this.categories", this.categories);
    data = data.concat(this.categories);
    console.warn("数据", data);
    this.navArray = data;
  },
  watch: {
    categories(newVal) {
      if (newVal) {
        let data = [
          {
            text: "All Posts",
          },
        ];
        data = data.concat(this.categories);
        this.navArray = data;
      }
    },
  },
  methods: {
    toSlide(index) {
      this.$refs.mySwiper.$swiper.slideTo(index, 0);
      this.slideTo(index);
    },
  },
};
</script>

<template>
  <div :class="$style.categoryNav" class="d-flex w-100 category-nav-slider">
    <Swiper class="swiper mx-0 w-100" :options="swiperOption" ref="mySwiper">
      <SwiperSlide
        v-for="(nav, index) in navArray"
        :key="index"
        :class="$style.cardWidth"
      >
        <a href="javascript:" @click="toSlide(index)">{{ nav.text }}</a>
      </SwiperSlide>
      <div slot="pagination" class="swiper-pagination"></div>
      <!-- <div slot="button-prev" class="swiper-button-prev"></div>
        <div slot="button-next" class="swiper-button-next"></div> -->
    </Swiper>
  </div>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.categoryNav {
  margin-top: 200px;
  a {
    font-family: $family-bold;
    font-size: 72px;
    color: $color-light-gray !important;
    text-decoration: none !important;
    &:hover {
      opacity: 0.9;
    }
  }
}
.cardWidth {
  width: auto !important;
}
@media only screen and (max-width: 767px) {
  .categoryNav {
    margin-top: 148px;
    a {
      font-size: 32px;
    }
  }
}
</style>
